import { type ComponentsOverrides, type Theme } from '@mui/material/styles'

export const overridesAppBar = (theme: Theme): ComponentsOverrides['MuiAppBar'] => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  colorPrimary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
})
